import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box
} from '@mui/material';

const EliminarPreguntaDialog = ({
  open,
  preguntaToDelete,
  onClose,
  onConfirmDelete
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle sx={{ color: "rgba(23,66,136,0.98)", fontWeight: 800 }}>
        ¿Eliminar pregunta?
      </DialogTitle>
      
      <DialogContent>
        <Box sx={{ color: "rgba(23,66,136,0.98)", fontWeight: 500, fontSize: 16 }}>
          Esta acción no se puede deshacer.<br />
          ¿Deseas eliminar la siguiente pregunta?
          <Box sx={{ mt: 2, p: 2, background: '#f5f5f5', borderRadius: 1 }}>
            <b>{preguntaToDelete?.pregunta}</b>
          </Box>
        </Box>
      </DialogContent>
      
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancelar
        </Button>
        <Button onClick={onConfirmDelete} color="error" variant="contained">
          Sí, eliminar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EliminarPreguntaDialog;